document.addEventListener('DOMContentLoaded', function () {
  const gallery = document.querySelector('.covet-pics-gallery');
  if (gallery) {
    const isCartAddRequest = (url) => { 
      try { 
        return /\/cart\/add(\.js)?$/i.test(new URL(url, location.origin).pathname); 
      } catch { 
        return false; 
      } 
    };

    async function refreshCartCountBubble() {
      try {
        const response = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        const cartData = await response.json();
        const itemCount = Number(cartData?.item_count) || 0;

        let bubbles = document.querySelectorAll('.cart-count-bubble, #cart-count-bubble');

        if (itemCount > 0) {
          if (bubbles.length === 0) {
            const bubbleContainer = document.getElementById('cart-icon-bubble') || document.body;
            const newBubble = document.createElement('div');
            newBubble.className = 'cart-count-bubble';
            const newCounter = document.createElement('span');
            newCounter.className = 'counter';
            newBubble.appendChild(newCounter);
            bubbleContainer.appendChild(newBubble);
            bubbles = [newBubble];
          }

          bubbles.forEach((bubble) => {
            let counterEl = bubble.querySelector('.counter');
            if (!counterEl) { 
              counterEl = document.createElement('span'); 
              counterEl.className = 'counter'; 
              bubble.appendChild(counterEl); 
            }
            counterEl.textContent = itemCount;
          });
        } else {
          bubbles.forEach((bubble) => bubble.remove());
        }
      } catch (_) {}
    }

    const nativeFetch = window.fetch;
    window.fetch = async function(input, init) {
      const response = await nativeFetch(input, init);

      try {
        const requestUrl = typeof input === 'string' ? input : input.url;
        if (isCartAddRequest(requestUrl)) {
          response.clone().text().then(async () => {
            if (document.querySelector('.covet-pics-popup-open')) {
              if (response.ok) {
                document.dispatchEvent(new CustomEvent('cart:item-added'));
              }

              if (window.innerWidth < 1024) {
                window.location.href = '/cart';
              } else {
                document.querySelector('cart-drawer')?.open?.();
                document.querySelector('cart-drawer-items')?.onCartUpdate?.();

                const emptyDrawer = document.querySelector('.drawer__inner-empty');
                if (emptyDrawer?.classList.contains('is-empty-inner')) emptyDrawer.classList.remove('is-empty-inner');

                const checkoutButton = document.querySelector('.cart__checkout-button[disabled]');
                if (checkoutButton) checkoutButton.removeAttribute('disabled');
              }
            }
            await refreshCartCountBubble();
          }).catch(refreshCartCountBubble);
        }
      } catch (_) {}

      return response;
    };
  }
});
